import styled from "styled-components";

export const IPFWrapper = styled.div`
    display: flex;
    justify-content: center;
`;